import { render, staticRenderFns } from "./ProposalButtonsGrid.vue?vue&type=template&id=a4e144ec&scoped=true"
import script from "./ProposalButtonsGrid.vue?vue&type=script&lang=js"
export * from "./ProposalButtonsGrid.vue?vue&type=script&lang=js"
import style0 from "./ProposalButtonsGrid.vue?vue&type=style&index=0&id=a4e144ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e144ec",
  null
  
)

export default component.exports